import Vue from '@src/vue'
import { CreateElement } from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { ContentBox } from '@src/elements/content-box/content-box'
import { Subtitle1 } from '@src/elements/typography/typography'
import { StateTicket } from '@src/data/support-ticket'
import { ErrorScreen } from '@src/components/error-screen/error-screen'
import { Ticket } from '@src/routes/support/components/exercises/ticket'

@Component
export class TicketsList extends Vue {

  @Prop({ required: true })
  type: StateTicket

  @Prop({ required: false, default: [] })
  tickets: Ticket[]

  @Prop({ required: false, default: null })
  extraMessage: any

  render (h: CreateElement) {

    if (this.tickets.length === 0) {
      return <ErrorScreen message={this.$t('SUPPORT_PAGE.SUPPORT_TICKET.NO_TICKETS')} />
    }

    return <div>
      <div class = {`${this.type.replace('_', '-')}-tickets`}>
        <div class='ticket-group-specs'>
          <Subtitle1>{this.$t(`SUPPORT_PAGE.SUPPORT_TICKET.${this.type.toUpperCase()}_TICKETS_INFO`)}</Subtitle1>
        </div>
        {this.extraMessage}
        <ContentBox class='ticket-group' overflow='scrollable'>
          <div slot='content'>
            {this.tickets}
          </div>
        </ContentBox>
      </div>
    </div>
  }
}
